import { ParamListBase } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import React from 'react'
import { View } from 'react-native'
import {
  Dropdown,
  DropdownItem,
  DropdownItemComponentProps,
  DropdownSection,
} from '../components/dropdown'
import { SideStepButtons } from '../components/sidestep_buttons'

export function showHeaderButtonDropdown<
  ParamList extends ParamListBase,
  RouteName extends keyof ParamList,
  Item extends DropdownItem = DropdownItem
>(
  navigation: StackNavigationProp<ParamList, RouteName>,
  sections: DropdownSection<Item>[],
  selectedId: any,
  onSelect: (id: any) => void,
  ItemComponent?: (props: DropdownItemComponentProps) => React.JSX.Element,
  hideDownArrow?: boolean,
  hideSideStepButtons?: boolean,
  icon?: { name: string; type: string; solid?: boolean }
) {
  navigation.setOptions({
    headerRight: () => (
      <View style={{ marginHorizontal: 5 }}>
        {hideSideStepButtons ? (
          <Dropdown
            sections={sections}
            selectedId={selectedId}
            onSelect={onSelect}
            ItemComponent={ItemComponent}
            hideDownArrow={hideDownArrow}
            icon={icon}
          />
        ) : (
          <SideStepButtons
            onSelect={onSelect}
            sections={sections}
            selectedId={selectedId}
          >
            <Dropdown
              sections={sections}
              selectedId={selectedId}
              onSelect={onSelect}
              ItemComponent={ItemComponent}
              hideDownArrow={hideDownArrow}
              icon={icon}
            />
          </SideStepButtons>
        )}
      </View>
    ),
  })
}
